import { render, staticRenderFns } from "./mainDealerChart.vue?vue&type=template&id=579980ce"
import script from "./mainDealerChart.vue?vue&type=script&lang=js"
export * from "./mainDealerChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports